import { z } from 'zod';

export const TransitRequestReleaseSchema = z.object({
  transitId: z.string().min(1, { message: 'Required' }),
  approveRevisions: z.boolean(),
});
export type TransitRequestReleaseData = z.infer<typeof TransitRequestReleaseSchema>;
